<template>
    <div>
        <v-card>
            <v-row class="ml-1 mr-1">
                <v-col cols="7">
                    <v-card-title class="titulopagina">REPORTE DE PRODUCCION POR ANTIOXIDANTE</v-card-title>
                </v-col>
                <v-col cols="1">
                    <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                        <v-icon color="blue" large>help</v-icon>
                    </v-alert>
                </v-col>
                <v-col cols="1">
                    <v-btn color="green darken-1" class="ml-2 float-right" small dark @click="cargarProduccionHarina()"><v-icon>refresh</v-icon></v-btn>
                </v-col>
                <v-col cols="3">
                    <date-picker class="float-right" v-model="fechas" range-separator="|" range placeholder ="Seleccione Rango de Fechas" format="DD-MM-YYYY" :default-value="fechas" valueType="YYYY-MM-DD"></date-picker>                        
                </v-col>
            </v-row>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <!--<v-card>
            <v-card-text>
                <v-row>
                    <v-col><h2>Reporte Produccion Por Antioxidante</h2></v-col>
                    <v-col>
                        <v-btn color="green darken-1" class="float-right" small dark @click="cargarProduccionHarina()"><v-icon>loop</v-icon></v-btn>
                        <date-picker v-model="fecha" placeholder ="Seleccione Fecha" format="DD-MM-YYYY" :default-value="fecha" valueType="YYYY-MM-DD" class="float-right mr-1"></date-picker>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>-->

        <v-row>
            <v-col>
                <v-card>
                    <!-- <v-card-title>
                    Titulo
                    <v-spacer></v-spacer>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                    </v-card-title> -->
                    <v-data-table
                    :headers="columnas"
                    :items="lista"
                    ></v-data-table>
                </v-card>
            </v-col>
        </v-row>

    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
export default {
    data:()=>({
        lista:[],
        fechas:null,
        columnas: [
            {
                text: 'Antioxidante',
                align: 'center',
                sortable: false,
                value: 'antioxidante',
                class: 'cabecera'
            },
            { text: 'Cantidad Maxisacos',
                align: 'center',
                sortable: false, 
                value: 'cantidad_jumbos',
                class: 'cabecera'
            },
            { text: 'Kilos',
                align: 'center',
                sortable: false,
                value: 'kilos' ,
                class: 'cabecera'
            },
        ],
    }),
    mounted() {
        this.fechas = this.moment().format('YYYY-MM-DD');
        this.cargarProduccionHarina();
    },
    methods: {
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Reporte de Producción Por Antioxidante`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra la cantidad de maxisacos y de kilos en total por cada antioxidante existente dentro del rango de fechas especificados.`},
                {   tipo:`label`,   texto:`- El rango de fechas se selecciona arriba a la derecha. Una vez indicado uno, se debe pulsar el botón verde a la izquierda con el icono de recargar para buscar la información.`},
                {   tipo:`label`,   texto:`- En la tabla se muestra el antioxidante, la cantidad de maxisacos y los kilos totales de ese rango de fechas.`},
            ];
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarProduccionHarina(){
            console.log('fechas',this.fechas);
            let url = `${this.base_url}produccion_harina/${this.fechas[0]}/${this.fechas[1]}`;
            await this.axios.get(url,this.headers).then((res)=>{
                console.log('respuesta',res.data);
                this.lista = res.data.data;
            }).catch((e)=>{
                console.log('error',e);
            });
        },

        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url','headers'])
    },
    components:{
        DatePicker,
        'modal-ayuda': ModalAyudas,
    }
}
</script>